import type { CrossModelParameterSpecification } from "@mm/api-layers.meteomatics.com";
import type { ExactLayerMatch } from "@mm/weather-parameter-utils";

export function getLanguageDescriptionField(locale2digit: string): keyof CrossModelParameterSpecification {
  switch (locale2digit) {
    case "en":
      return "description_en";
    case "de":
      return "description_de";
    case "fr":
      return "description_fr";
    default:
      return "description_en";
  }
}

export function indexWasMatched(matchingLayers: ExactLayerMatch[], i: number): boolean {
  return void 0 !== matchingLayers.find((x) => x.layerIdx === i);
}
